import { Routes, Route } from 'react-router-dom';
import Home from './Home';
import Marketing from './Marketing';
import WebDevelopment from './WebDevelopment';
import Contact from './Contact';
import About from './About';
import './App.css';

function App() {

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/marknadsforing" element={<Marketing />} />
      <Route path="/webbutveckling" element={<WebDevelopment />} />
      <Route path="/kontakt" element={<Contact />} />
      <Route path="/om-oss" element={<About />} />
    </Routes>
  );
}

export default App;
